// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RightBar_mainCt__ZxbAl {
    z-index: 100;
    position: fixed;
    right: 0;
    top: 64px;
    width: 20%;
    height: calc(100% - 64px);
    display: flex;
    flex-direction: column;
    background-color: #00102982;
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
    transition: transform 0.3s ease-in-out;
    border: 1px solid #ffffff61;
    border-right: 0;
}
.RightBar_timeReg__zX6kU{
    color: white;
    /*text-shadow: 0 0 20px rgba(10, 175, 230, 1),  0 0 20px rgba(10, 175, 230, 0);*/

    letter-spacing: 0.05em;
    font-size: 25px;
    padding: 5px 0;
}
.RightBar_mainCt__ZxbAl.RightBar_hidden__vAXyC {
    transform: translateX(100%); /* Slide out of view */
}

.RightBar_mainCt__ZxbAl.RightBar_visible__tPmkJ {
    transform: translateX(0); /* Slide into view */
}

.RightBar_toggleButton__T8BAQ {
    position: absolute;
    left: -20px; /* Adjust based on icon size */
    top: 50%;
    transform: translateY(-50%);
    background-color: #00336fad;
    border: none;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: white;
    z-index: 4; /* Ensure it's above the panel */
}

.RightBar_toggleButton__T8BAQ:hover {
    background-color: #000531;
}
.RightBar_buttonAuction__fNqPr{
    display: flex;
    justify-content: center;
    padding: 0;
    font-size: 16px;
    background-color: #554caf;
}
.RightBar_blockUser__wTUmt{
    display: flex;
    gap:10px;
    align-items: center;
    color: white;
    font-family: Popins,sans-serif;
    letter-spacing: 1px;
    white-space: wrap;
    font-size: 17px;
    
}
.RightBar_avatarsBlock__UGPsU{
    display: flex;
    flex-direction: column;
}
.RightBar_header__6KwND{
    display: flex;
    justify-content: space-between;
    border-bottom: 0.5px rgba(153, 152, 152, 0.5) solid;
    padding: 10px;
    align-items: center;
    flex-shrink: 0;
    overflow: visible;
    background: #ffffff24;
    border-top-left-radius: inherit;
}
.RightBar_blockGames__bePZt {
    display: flex;
    flex-shrink: 0;
    overflow: auto;
    flex-direction: column;
    background: #ffffff0f;
    
}
.RightBar_games__R2j\\+c{
    display: flex;
    padding:10px;
    flex-direction: column;
    gap:10px;
   
}
.RightBar_games__R2j\\+c a{
    width: 50%;
    border-radius: 10px;
}
.RightBar_blockGame__tuspa{
    display: flex;
    flex-direction: column;
    text-align: center;
    color:white;
    font-family: Popins,sans-serif;
    font-size: 20px;
    gap:10px;
}
.RightBar_blockAuction__-B5xN{
    display: flex;
    flex-direction: column;
    text-align: center;
    color:white;
    font-family: Popins,sans-serif;
    font-size: 17px;
    background: linear-gradient(315deg, rgb(133, 122, 8) 0%, rgba(243, 218, 132, 0.66) 100%);
    border-radius: 10px;
    cursor: pointer;
    padding: 5px 20px;
}
.RightBar_blockGame__tuspa img{
    width: 33%;
    border-radius: 10px;
    
}
.RightBar_blockGame__tuspa div{
    
}
.RightBar_chatContainer__kC68A {
    flex: 1 1; /* Чтобы Chat занимал оставшееся пространство */
    display: flex;
    flex-direction: column;
}
@media screen and (max-width: 1000px) {
    .RightBar_mainCt__ZxbAl{
        width: 96%;
        right: 2%;
        height: calc(100% - 135px);
        top: 64px;
        border-radius: 20px;
        border-right: 1px solid #ffffff61;
        background-color: #010013fa;
    }
    .RightBar_header__6KwND{
        border-bottom: 0.5px rgb(186, 186, 186) solid;
    }
    .RightBar_toggleButton__T8BAQ {
        display: none;
        left: unset;
        right: -2%;
        border: 1px solid #ffffff5e;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/RightBar/RightBar.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,eAAe;IACf,QAAQ;IACR,SAAS;IACT,UAAU;IACV,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,+BAA+B;IAC/B,sCAAsC;IACtC,2BAA2B;IAC3B,eAAe;AACnB;AACA;IACI,YAAY;IACZ,gFAAgF;;IAEhF,sBAAsB;IACtB,eAAe;IACf,cAAc;AAClB;AACA;IACI,2BAA2B,EAAE,sBAAsB;AACvD;;AAEA;IACI,wBAAwB,EAAE,oBAAoB;AAClD;;AAEA;IACI,kBAAkB;IAClB,WAAW,EAAE,8BAA8B;IAC3C,QAAQ;IACR,2BAA2B;IAC3B,2BAA2B;IAC3B,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,UAAU,EAAE,gCAAgC;AAChD;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,UAAU;IACV,eAAe;IACf,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,YAAY;IACZ,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;;AAEnB;AACA;IACI,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,mDAAmD;IACnD,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,qBAAqB;IACrB,+BAA+B;AACnC;AACA;IACI,aAAa;IACb,cAAc;IACd,cAAc;IACd,sBAAsB;IACtB,qBAAqB;;AAEzB;AACA;IACI,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,QAAQ;;AAEZ;AACA;IACI,UAAU;IACV,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,8BAA8B;IAC9B,eAAe;IACf,QAAQ;AACZ;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,8BAA8B;IAC9B,eAAe;IACf,wFAAwF;IACxF,mBAAmB;IACnB,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,UAAU;IACV,mBAAmB;;AAEvB;AACA;;AAEA;AACA;IACI,SAAO,EAAE,+CAA+C;IACxD,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI;QACI,UAAU;QACV,SAAS;QACT,0BAA0B;QAC1B,SAAS;QACT,mBAAmB;QACnB,iCAAiC;QACjC,2BAA2B;IAC/B;IACA;QACI,6CAA6C;IACjD;IACA;QACI,aAAa;QACb,WAAW;QACX,UAAU;QACV,2BAA2B;IAC/B;AACJ","sourcesContent":[".mainCt {\n    z-index: 100;\n    position: fixed;\n    right: 0;\n    top: 64px;\n    width: 20%;\n    height: calc(100% - 64px);\n    display: flex;\n    flex-direction: column;\n    background-color: #00102982;\n    border-top-left-radius: 20px;\n    border-bottom-left-radius: 20px;\n    transition: transform 0.3s ease-in-out;\n    border: 1px solid #ffffff61;\n    border-right: 0;\n}\n.timeReg{\n    color: white;\n    /*text-shadow: 0 0 20px rgba(10, 175, 230, 1),  0 0 20px rgba(10, 175, 230, 0);*/\n\n    letter-spacing: 0.05em;\n    font-size: 25px;\n    padding: 5px 0;\n}\n.mainCt.hidden {\n    transform: translateX(100%); /* Slide out of view */\n}\n\n.mainCt.visible {\n    transform: translateX(0); /* Slide into view */\n}\n\n.toggleButton {\n    position: absolute;\n    left: -20px; /* Adjust based on icon size */\n    top: 50%;\n    transform: translateY(-50%);\n    background-color: #00336fad;\n    border: none;\n    border-radius: 50%;\n    width: 30px;\n    height: 30px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    color: white;\n    z-index: 4; /* Ensure it's above the panel */\n}\n\n.toggleButton:hover {\n    background-color: #000531;\n}\n.buttonAuction{\n    display: flex;\n    justify-content: center;\n    padding: 0;\n    font-size: 16px;\n    background-color: #554caf;\n}\n.blockUser{\n    display: flex;\n    gap:10px;\n    align-items: center;\n    color: white;\n    font-family: Popins,sans-serif;\n    letter-spacing: 1px;\n    white-space: wrap;\n    font-size: 17px;\n    \n}\n.avatarsBlock{\n    display: flex;\n    flex-direction: column;\n}\n.header{\n    display: flex;\n    justify-content: space-between;\n    border-bottom: 0.5px rgba(153, 152, 152, 0.5) solid;\n    padding: 10px;\n    align-items: center;\n    flex-shrink: 0;\n    overflow: visible;\n    background: #ffffff24;\n    border-top-left-radius: inherit;\n}\n.blockGames {\n    display: flex;\n    flex-shrink: 0;\n    overflow: auto;\n    flex-direction: column;\n    background: #ffffff0f;\n    \n}\n.games{\n    display: flex;\n    padding:10px;\n    flex-direction: column;\n    gap:10px;\n   \n}\n.games a{\n    width: 50%;\n    border-radius: 10px;\n}\n.blockGame{\n    display: flex;\n    flex-direction: column;\n    text-align: center;\n    color:white;\n    font-family: Popins,sans-serif;\n    font-size: 20px;\n    gap:10px;\n}\n.blockAuction{\n    display: flex;\n    flex-direction: column;\n    text-align: center;\n    color:white;\n    font-family: Popins,sans-serif;\n    font-size: 17px;\n    background: linear-gradient(315deg, rgb(133, 122, 8) 0%, rgba(243, 218, 132, 0.66) 100%);\n    border-radius: 10px;\n    cursor: pointer;\n    padding: 5px 20px;\n}\n.blockGame img{\n    width: 33%;\n    border-radius: 10px;\n    \n}\n.blockGame div{\n    \n}\n.chatContainer {\n    flex: 1; /* Чтобы Chat занимал оставшееся пространство */\n    display: flex;\n    flex-direction: column;\n}\n@media screen and (max-width: 1000px) {\n    .mainCt{\n        width: 96%;\n        right: 2%;\n        height: calc(100% - 135px);\n        top: 64px;\n        border-radius: 20px;\n        border-right: 1px solid #ffffff61;\n        background-color: #010013fa;\n    }\n    .header{\n        border-bottom: 0.5px rgb(186, 186, 186) solid;\n    }\n    .toggleButton {\n        display: none;\n        left: unset;\n        right: -2%;\n        border: 1px solid #ffffff5e;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainCt": `RightBar_mainCt__ZxbAl`,
	"timeReg": `RightBar_timeReg__zX6kU`,
	"hidden": `RightBar_hidden__vAXyC`,
	"visible": `RightBar_visible__tPmkJ`,
	"toggleButton": `RightBar_toggleButton__T8BAQ`,
	"buttonAuction": `RightBar_buttonAuction__fNqPr`,
	"blockUser": `RightBar_blockUser__wTUmt`,
	"avatarsBlock": `RightBar_avatarsBlock__UGPsU`,
	"header": `RightBar_header__6KwND`,
	"blockGames": `RightBar_blockGames__bePZt`,
	"games": `RightBar_games__R2j+c`,
	"blockGame": `RightBar_blockGame__tuspa`,
	"blockAuction": `RightBar_blockAuction__-B5xN`,
	"chatContainer": `RightBar_chatContainer__kC68A`
};
export default ___CSS_LOADER_EXPORT___;
